import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";
import { analytics } from "@/lib/analytics";
import { FileText } from "lucide-react";

export function ReportExampleButton({
  variant,
}: {
  variant?: "default" | "short";
}) {
  const { t } = useCommonTranslation();

  const isShort = variant === "short";

  return (
    <a
      href="/report/example"
      className="group inline-flex items-center gap-3 py-3 text-md font-medium text-purple-600 underline decoration-dotted underline-offset-4 transition-colors duration-200 hover:text-purple-700 hover:decoration-solid"
      onClick={() => {
        analytics.trackFunnelEvent("sample_report_clicked", {
          variant: isShort ? "short" : "default",
        });
      }}
    >
      <FileText className="size-5" />
      {isShort ? t("landing:sample_report") : t("landing:view_sample_report")}
    </a>
  );
}
